import Icons from '@shared/components/core/images/Icons';
import {
    ActionWrapper,
    Content,
    EmptyContent,
    ListingCard,
    Table,
    TableHeading,
} from '@shared/components/core/listing/CommonListingStyles';
import { CardTitleCentered } from '@shared/components/core/text/CardTypography';
import { BodySmall } from '@shared/components/core/text/Typography';
import { commandTypesDisplay } from '@shared/constants/CommandValues';
import { getCommandDisplayName } from '@shared/hooks/helpers/profileUtils';
import { AudioEventDisplayModel } from '@shared/models/deviceProfiles/AudioEventModel';
import { useTranslation } from 'react-i18next';

export interface ITalkbackListingProps {
    audioEvents: AudioEventDisplayModel[];
    showDescription?: boolean;
}

function TalkbackListing({ audioEvents, showDescription = true }: ITalkbackListingProps) {
    const { t } = useTranslation();
    return (
        <ListingCard>
            {audioEvents.length > 0 ? (
                <>
                    <CardTitleCentered>{t('common:talkback.title')}</CardTitleCentered>
                    {showDescription && <BodySmall>{t('common:talkback.description')}</BodySmall>}

                    <Table>
                        <thead>
                            <ActionWrapper>
                                <Content as="th">
                                    <TableHeading>{t('common:when')}</TableHeading>
                                </Content>
                                <Content as="th">
                                    <TableHeading>{t('common:talkback.thenMacro')}</TableHeading>
                                </Content>
                            </ActionWrapper>
                        </thead>
                        <tbody>
                            {audioEvents.map((e, i) => {
                                const commands = e.commands;
                                return commands.map((c, commandId) => {
                                    const icon = commandTypesDisplay[c.commandType];
                                    return (
                                        <ActionWrapper key={`audioEvents_${i}_${commandId}`}>
                                            <Content>
                                                <Icons name={icon.icon} size={24} ariaLabel={t(icon.title)} />
                                                <p>{getCommandDisplayName(c.command, t)}</p>
                                            </Content>
                                            <Content>
                                                <p>{e.outputSpeech}</p>
                                                <Icons name="speaker" size={24} ariaLabel={t('common:steps')} />
                                            </Content>
                                        </ActionWrapper>
                                    );
                                });
                            })}
                        </tbody>
                    </Table>
                </>
            ) : (
                <EmptyContent>{t('common:talkback.empty')}</EmptyContent>
            )}
        </ListingCard>
    );
}

export default TalkbackListing;
